import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Jumbotron from "./Jumbotron";
import Motto from "./Motto";
import Rcollection from "./RCollection";
import Footer from "./Footer";

import BgImage from "../images/abstract.jpg";

import { myMottos } from "../data/ValueArray";

const HomePage = (props) => {
  const [randomNumber, setRandomNumber] = useState(0); // salvo qui il numero da usare per pescare nell'array dei motti

  //devo trovare un numero casuale nel range datomi dal numero totale dei "motti" salvati in myMottos
  const generateRandomNumber = () => {
    const randomNum = Math.floor(Math.random() * myMottos.length);
    setRandomNumber(randomNum);
  };

  // useEffect chiama la funzione che mi genera il numero casuale da utilizzare nell'array myMottos
  useEffect(() => {
    generateRandomNumber();
  }, []);

  console.log(randomNumber);

  return (
    <div className="wrapper">
      <Navbar />
      <Jumbotron
        BgImage={BgImage}
        titolo="DIDA Ricerche"
        lead="L'attività di promozione delle opportunità di finanziamento e di progettazione riguarda tutti i fondi europei a gestione diretta, come Horizon 2020, Erasmus plus e Creative Europe"
      />
      {/* <Motto motto="“La ricerca è l'atto di percorrere i vicoli per vedere se sono ciechi”" /> */}
      {/* passo il motto al component 'motto' pescandolo dall'array myMottos*/}
      <Motto
        motto={myMottos[randomNumber].motto}
        autore={myMottos[randomNumber].autore}
      />
      <Rcollection {...props} />
      <Footer />
    </div>
  );
};

export default HomePage;
